/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumNgModalSize {
	Small 		= 'sm',
	Medium 		= 'md',
	Large 		= 'lg',
	ExtraLarge 	= 'xl'
}
